var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    root: {
        backgroundColor: '#FFFFFF',
        paddingLeft: '10px',
        height: '100%',
        width: '100%',
    },
    elem: {
        fontFamily: 'Segoe UI',
        fontSize: '24px',
    },
    dataGridStyles: {
        root: {
            '.datagrid-class': {
                padding: '15px',
                height: '560px',
            },
            '.ms-DetailsRow-cell': {
                borderRight: '1px solid lightgrey',
            },
            '.ms-DetailsHeader-cellTitle': {
                borderRight: '1px solid lightgrey',
                borderTop: '1px solid lightgrey',
            },
            '.ms-DetailsHeader': {
                paddingTop: 0,
            },
        },
        contentWrapper: {
            '.ms-SelectionZone': {
                fontHeight: '0px',
            },
            height: '0px',
        },
        ['data-item-key=actions']: {
            width: '100px',
        },
    },
    stickyDataGridStyles: {
        root: {
            '.datagrid-class': {
                padding: '10px',
                height: '560px',
            },
            '.ms-DetailsRow-cell': {
                borderRight: '1px solid lightgrey',
            },
            '.ms-DetailsHeader-cellTitle': {
                borderTop: '1px solid lightgrey',
            },
            '.ms-DetailsHeader': {
                paddingTop: 0,
                height: '60px',
            },
        },
        contentWrapper: {
            '.ms-SelectionZone': {
                fontHeight: '0px',
            },
            height: '0px',
        },
        ['data-item-key=actions']: {
            width: '100px',
        },
    },
};
export const headerStyle = {
    root: {
        paddingTop: 0,
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
            },
            '.ms-DetailsHeader': {
                paddingTop: 0,
            },
            '.ms-DetailsList': {
                borderBottom: 'none',
            },
        },
    },
};
export const bookedHoursHeaderStyle = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
            },
            '.ms-DetailsHeader': {
                backgroundColor: '#FAF9F8',
            },
            '.ms-DetailsHeader-cellTitle': {
                borderRight: 'none',
            },
        },
        backgroundColor: '#FAF9F8',
    },
};
export const dataCellStyles = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
            },
            '.ms-DetailsHeader-cell': {
                width: '50px',
            },
            '.ms-DetailsHeader-cellTitle': {
                justifyContent: 'center',
            },
        },
    },
};
export const adjustMarginStyles = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                marginTop: '10px',
            },
        },
    },
};
export const darkBackgroundStyles = {
    root: {
        backgroundColor: '#FAF9F8',
    },
};
export const removeBorderStyles = {
    root: {
        selectors: {
            '.ms-DetailsRow-cell': {
                borderRight: 'none',
                borderLeft: 'none',
            },
            '.ms-DetailsHeader-cellTitle': {
                borderRight: 'none',
                borderTop: '1px solid lightgrey',
                borderLeft: 'none',
            },
        },
    },
};
export const weekHeaderStyle = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
            },
        },
    },
};
export const stickyFooterStyle = {
    root: {
        selectors: {
            '.ms-Stack': {
                position: 'fixed',
                bottom: 0,
                zIndex: 5,
                backgroundColor: 'white',
            },
        },
    },
};
//# sourceMappingURL=StickyFooterComponent.styles.js.map